import { Container } from "./styles";

const Spinner = () => {
  return (
    <Container>
      <div></div>
      <div></div>
      <div></div>
    </Container>
  );
};

export default Spinner;
